import React from "react";
import { useOverlays } from "contexts/OverlayContext";
import { Button } from "@design-system/Button/Button";
import styles from "./InvoiceTemplateCreatedToast.module.scss";

interface Props {
    templateId: string;
    entityId: number;
}

// Shown after a new invoice template is created and its create drawer
// closes. The "Create invoice" action opens the same apply-template flow as
// picking the template manually from the templates list (openOverlay +
// applyTemplate), so the new create-invoice session starts from a blank
// form and the template is applied directly — matching how
// InvoiceTemplatesList.handleCreateInvoice starts its flow, so the
// not-empty override-confirmation logic never sees a populated form to
// second-guess.
export const InvoiceTemplateCreatedToast: React.FC<Props> = ({
    templateId,
    entityId,
}) => {
    const { openOverlay } = useOverlays();

    return (
        <div className={styles.content}>
            <p className={styles.message}>Template created</p>
            <div className={styles.actions}>
                <Button
                    variant="primary"
                    size="md"
                    onClick={() =>
                        openOverlay("nativeInvoiceDrawer", {
                            applyTemplate: { templateId, entityId },
                        })
                    }
                >
                    Create invoice
                </Button>
            </div>
        </div>
    );
};
